export default "__VITE_ASSET__41985f31__"